import { createAsyncThunk } from '@reduxjs/toolkit';
import { apiFetch } from '../../../utilities/appFetch';
import permissionGroupRoutes from '../../../components/permissionGroup/permissionGroupRoutes';

const update = createAsyncThunk(
  'thunk/permissionGroup/delete',
  async (arg, thunkAPI) => {
    const response = await apiFetch(permissionGroupRoutes.api.generate.delete(arg?.id), {
      method: 'DELETE',
    });
    if (!response?.success) {
      return thunkAPI.rejectWithValue(response);
    }
    return response.result;
  },
);

export default update;
